import { render, staticRenderFns } from "./sqlc.vue?vue&type=template&id=6458c546&scoped=true"
import script from "./sqlc.vue?vue&type=script&lang=js"
export * from "./sqlc.vue?vue&type=script&lang=js"
import style0 from "./sqlc.vue?vue&type=style&index=0&id=6458c546&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6458c546",
  null
  
)

export default component.exports